import React, { useState, useContext, useEffect, useRef } from "react";
import { FiEdit } from "react-icons/fi";
import AuthContext from "../../context/auth/authContext";
import { formatPrice, formatNumberNormally } from "../../helpers/format";
import styles from "../../styles/Profile/BasicProfile.module.css";
import { AiOutlineCamera } from "react-icons/ai";
import { TiTick } from "react-icons/ti";
import ReactTooltip from "react-tooltip";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

import ChangePassword from "../../components/auth/ChangePassword";
import { MdContentCopy } from "react-icons/md";
import Compressor from "compressorjs";
import firebase from "../../firebase";
import { FaMoneyBill, FaWallet } from "react-icons/fa";
import Transaction from "./Transaction";
import _ from "lodash";
import NumberFormat from "react-number-format";

const Profile = () => {
  const {
    userData,
    getAmountInWallet,

    editProfile,
    walletData,
    clearTransactions,
  } = useContext(AuthContext);
  const [isEdit, setIsEdit] = useState(false);
  const [email, setEmail] = useState(userData && userData.profile_data.email);
  const [name, setName] = useState(userData && userData.profile_data.name);
  const [showChangePasswordScreen, setShowChangePasswordScreen] =
    useState(false);
  const [mobile, setMobile] = useState(
    userData && userData.profile_data.mobile
  );
  const [userName, setUserName] = useState(
    userData && userData.profile_data.userName
  );
  const inputFile = useRef(null);
  // const [password, setPassword] = useState("");

  const nameInput = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [imgSrc, setImgSrc] = useState(userData.profile_data.avatar);
  const [toSave, setToSave] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const [close, setClose] = useState(false);
  useEffect(() => {
    clearTransactions();
    getAmountInWallet(1);
    //eslint-disable-next-line
  }, []);
  const closeChangePasswordScreen = () => {
    setShowChangePasswordScreen(false);
  };
  const handleFile = (e) => {
    if (e.target.files[0] && e.target.files[0]?.size > 2 * 1024 * 1024) {
      toast.error("Image cannot exceed 2MB", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (e.target.files[0] && e.target.files[0].size <= 2 * 1024 * 1024) {
      new Compressor(e.target.files[0], {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult) => {
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.

          setSelectedFile(compressedResult);

          const objectURL = URL.createObjectURL(compressedResult);

          setImgSrc(objectURL);
          setToSave(true);
        },
      });
    }
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(
      `Join me on Coinstorey by installing Coinstorey app through my referral code ${userData.profile_data.user_referral_code}`
    );
    setClose(!close);
    setTimeout(() => setClose(false), 2000);
  };
  const handleClick = () => {
    if (selectedFile) {
      setImgLoading(true);
      const ref = firebase
        .storage()
        .ref(`${userData.profile_data.name}@${new Date().getTime()}`);
      const uploadTask = ref.put(selectedFile);
      uploadTask.on("state_changed", console.log, console.error, () => {
        ref.getDownloadURL().then((url) => {
          if (url) {
            editProfile({ avatar: url });
            setSelectedFile(null);
          } else {
            setImgSrc((prev) => prev);
          }
          setImgLoading(false);
          setToSave(false);
        });
      });
    }
  };
  const handleSave = () => {
    if (userName.length > 16) {
      toast.error(
        "UserName cannot exceed 16 characters and it should be unique",
        { autoClose: 6000 }
      );
    } else if (name.length > 25) {
      toast.error("Name cannot exceed 25 characters", { autoClose: 6000 });
    } else if (
      !/(((^[+,0][9][1])(((\s[0-9]{7,10})|(\S[0-9]{7,10}))|([-]\S[0-9]{7,10})))|((^[+,0][2]{2,2})((\S[0-9]{7,8})|((([-])[0-9]{7,8})|(\s[0-9]{7,8})))))|(((^[6,7,8,9][0-9]{9,9}))|(^[0,+](([9][1)|[6,7,8,9]))[0-9]{8,9}))/gm.test(
        mobile
      )
    ) {
      toast.error("Please enter a valid mobile number", { autoClose: 6000 });
    } else {
      editProfile({ name, userName, mobile });
      setIsEdit(!isEdit);
    }
  };

  return userData &&
    typeof userData !== "undefined" &&
    userData.VirtualPortfolio &&
    walletData ? (
    <div className={styles.Profile}>
      {showChangePasswordScreen && (
        <ChangePassword close={closeChangePasswordScreen} />
      )}
      <div className={styles.Profile__Container}>
        <div className={styles.Profile__Box}>
          <div className={styles.Profile__left}>
            <div className={styles.Profile__img}>
              {userData?.profile_data ? (
                <div>
                  <center>
                    {" "}
                    <div
                      style={{
                        position: "relative",
                        width: "180px",
                        height: "180px",
                      }}
                    >
                      <img
                        src={imgSrc}
                        alt="avatar"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          margin: "auto",
                        }}
                      />
                      {imgLoading ? (
                        <div>
                          <div
                            className="loader1"
                            style={{
                              position: "absolute",
                              zIndex: 3,
                              top: "40%",
                              left: "40%",
                            }}
                          ></div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div
                        className={styles.fileImg}
                        style={{
                          borderRadius: toSave ? "3px" : "50%",
                          right: toSave ? "-20px" : "0px",
                          bottom: toSave ? 0 : "20px",
                        }}
                      >
                        <input
                          type="file"
                          id="file"
                          ref={inputFile}
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleFile}
                        />
                        <span
                          onClick={() => inputFile.current.click()}
                          data-tip="Upload"
                          data-for="upload"
                        >
                          <ReactTooltip
                            place="right"
                            effect="float"
                            id="upload"
                          />
                          <AiOutlineCamera size={24} />
                        </span>

                        {toSave && (
                          <span
                            onClick={handleClick}
                            data-tip="Save"
                            data-for="#save"
                          >
                            <ReactTooltip
                              place="right"
                              id="#save"
                              effect="float"
                            />

                            <TiTick size={24} />
                          </span>
                        )}
                      </div>
                    </div>
                  </center>

                  <p style={{ fontSize: "18px", margin: "20px 0" }}>
                    {userData.profile_data.name}
                  </p>

                  <div
                    className="TradathonRoom__copyToClipboardContainer__input"
                    style={{ width: "50%", margin: "auto" }}
                    onClick={handleCopy}
                  >
                    <input
                      style={{ margin: 0 }}
                      type="text"
                      readOnly
                      value={`${userData.profile_data.user_referral_code}`}
                    />
                    <button
                      className="TradathonRoom__copyToClipboard__icon"
                      style={{ width: "50%" }}
                    >
                      <MdContentCopy size={20} />
                    </button>
                  </div>
                  {close ? (
                    <div className="TradathonRoom__copyToClipboardContainer__tooltip">
                     Referral code copied successfully
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className={styles.walletDetailsCard}>
              <section className={styles.section1}>
                <p>
                  <FaMoneyBill
                    style={{ color: "#45AA43", width: "24px", height: "20px" }}
                  />
                  <span>My Winnings</span>
                </p>{" "}
                <p style={{ color: "#45AA43" }}>
                  <NumberFormat
                    value={formatPrice(walletData.contestWinAmt)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix="₹"
                  />
                </p>
              </section>
              <section className={styles.section1}>
                <p>
                  <FaWallet style={{ width: "24px", height: "20px" }} />
                  <span>Virtual Money</span>
                </p>{" "}
                <p style={{ color: "#45AA43" }}>
                  <NumberFormat
                    value={formatPrice(
                      _.sum(userData.VirtualPortfolio.map((c) => c.curramount))
                    )}
                    displayType={"text"}
                    thousandSeparator={true}
                    // prefix={currencySymbol}
                    suffix={"CST"}
                  />
                </p>
              </section>
            </div>
          </div>
          <div className={styles.Profile__right}>
            <div className="Register__form">
              <p>Username</p>
              <input
                type="text"
                placeholder="&#xF007;&nbsp; Enter your Username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                readOnly={!isEdit}
                ref={nameInput}
              />
              <p>Name</p>
              <input
                type="text"
                placeholder="&#xF007;&nbsp; Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                readOnly={!isEdit}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>Email Address</p>
                <p
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowChangePasswordScreen(true)}
                >
                  Change Password
                </p>
              </div>

              <input
                type="email"
                placeholder="&#xF003;&nbsp; Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                readOnly
              />
              <p>Mobile No</p>
              <input
                type="text"
                placeholder="&#xf879;&nbsp; Enter your mobile number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                readOnly={!isEdit}
              />
              {/* 
              <p>Username</p>
              <input
                type="text"
                placeholder="&#xF007;&nbsp; Enter your username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                readOnly={!isEdit}
              /> */}
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {userData.profile_data.name !== name ||
              userData.profile_data.userName !== userName ||
              userData.profile_data.mobile !== mobile ? (
                <button
                  className={styles.Profile__Save_button}
                  onClick={handleSave}
                >
                  &nbsp;&nbsp;SAVE&nbsp;&nbsp;
                </button>
              ) : (
                <button
                  className={styles.Profile__Save_button}
                  onClick={() => {
                    setIsEdit(true);
                    nameInput.current.focus();
                  }}
                >
                  <FiEdit />
                  &nbsp; Edit&nbsp;
                </button>
              )}

              {isEdit && (
                <button
                  className={styles.Profile__Save_button}
                  onClick={() => {
                    setEmail(userData && userData.profile_data.email);
                    setName(userData && userData.profile_data.name);
                    setMobile(userData && userData.profile_data.mobile);
                    setUserName(userData && userData.profile_data.userName);
                    setIsEdit(!isEdit);
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
          {userData && (
            <div className={styles.walletDetailsCard}>
              <section>
                <p>Strike Rate</p>
                <p style={{ color: "#45AA43" }}>
                  {userData.contestJoined !== 0
                    ? `${formatNumberNormally(
                        (userData.contestWon / userData.contestJoined) * 100,
                        2
                      )}%`
                    : "0%"}
                </p>
              </section>
              <section>
                <div className="meter">
                  <span
                    style={{
                      width:
                        userData.contestJoined !== 0
                          ? `${
                              (userData.contestWon / userData.contestJoined) *
                              100
                            }%`
                          : 0,
                    }}
                  >
                    <span
                      className="progressbar"
                      style={{
                        background:
                          "linear-gradient(90deg, #8d0792 0%, #FA02FF 100.02%)",
                      }}
                    ></span>
                  </span>
                </div>

                {/* <div className={styles.progressholder}>
                  <div
                    className={styles.progressbar}
                    style={{ width: `${0.5 * 100}%` }}
                  ></div>
                </div> */}
              </section>
              <section className={styles.lastSection}>
                <div>
                  <p>Contests Played</p>
                  <p>{userData.contestJoined}</p>
                </div>
                <div
                  style={{ height: "40px", borderRight: "1px solid #E9E9E9" }}
                />
                <div>
                  <p>Contests Won</p>
                  <p>{userData.contestWon}</p>
                </div>
              </section>
            </div>
          )}
        </div>
        <Transaction />
      </div>
    </div>
  ) : (
    <center style={{ marginTop: "20px" }}>
      <Loader />
    </center>
  );
};

export default Profile;
